import { useTranslation } from 'react-i18next';
import { formatRsCalendarMonthTitle } from '../../utils/reservationBoardCalendar.util';
import styles from './ReservationBoardCalendar.module.css';

type RsMonthNavProps = {
  year: number;
  month: number;
  isViewingCurrentMonth: boolean;
  onPrev: () => void;
  onToday: () => void;
  onNext: () => void;
};

/**
 * 1行: [◂] 年月（非当月ならタップで今月） [▸]
 * タイトル行＋3ボタンの2段をやめ、sticky 帯を圧縮する。
 */
export default function RsMonthNav({
  year,
  month,
  isViewingCurrentMonth,
  onPrev,
  onToday,
  onNext,
}: RsMonthNavProps) {
  const { t, i18n } = useTranslation();
  const monthTitle = formatRsCalendarMonthTitle(i18n.language, year, month);

  return (
    <div className={styles.monthNavSection}>
      <div
        className={styles.monthNav}
        role="group"
        aria-label={t('reservation.board.monthNavAria', { defaultValue: '月の移動' })}
      >
        <button
          type="button"
          className={`${styles.monthNavBtn} ${styles.monthNavBtnPrev}`}
          onClick={onPrev}
          aria-label={t('reservation.board.monthNavPrev', { defaultValue: '前月' })}
        >
          <span className={styles.monthNavBtnIcon} aria-hidden="true">
            ◂
          </span>
        </button>
        <button
          type="button"
          className={`${styles.monthNavBtn} ${styles.monthNavBtnToday} ${
            isViewingCurrentMonth ? styles.monthNavBtnTodayActive : ''
          }`}
          onClick={onToday}
          disabled={isViewingCurrentMonth}
          aria-label={
            isViewingCurrentMonth
              ? monthTitle
              : t('reservation.board.monthNavGoToday', {
                  defaultValue: '今月へ戻る',
                })
          }
          aria-current={isViewingCurrentMonth ? 'date' : undefined}
          title={
            isViewingCurrentMonth
              ? monthTitle
              : t('reservation.board.monthNavTodayHint', {
                  defaultValue: 'タップで今月へ',
                })
          }
        >
          <span className={styles.monthNavTitleInBtn}>{monthTitle}</span>
          {!isViewingCurrentMonth ? (
            <span className={styles.monthNavTodayHint} aria-hidden="true">
              {t('reservation.board.monthNavToday', { defaultValue: '今月へ' })}
            </span>
          ) : null}
        </button>
        <button
          type="button"
          className={`${styles.monthNavBtn} ${styles.monthNavBtnNext}`}
          onClick={onNext}
          aria-label={t('reservation.board.monthNavNext', { defaultValue: '次月' })}
        >
          <span className={styles.monthNavBtnIcon} aria-hidden="true">
            ▸
          </span>
        </button>
      </div>
    </div>
  );
}
